import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MobileLeftSection from "../../Components/MobileLeftSection";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import { FaBookReader } from "react-icons/fa";
import { MdOutlineMenuBook } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import HTMLFlipBook from "react-pageflip";

export default function BookReaderMobile({
  BookDetails,
  bookId,
  book,
  BookPage,
  setBookPage,
  bookDet,
}) {
  const [SideOpener, setSideOpner] = useState(false);
  const dispatch = useDispatch();
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  const Navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} Page="Books" />
        <div className="main-content">
          <MobileHeaderSection Page="Books" OpenSideMenu={OpenSideMenu} />
          <div className="Books_Reader" style={{ padding: "20px" }}>
            {" "}
            <div id="reader" class="page">
              <header class="reader-header">
                <button
                  class="back-btn"
                  onClick={() => window.open("/student/books")}
                >
                  ←
                </button>
                <div class="reader-title">
                  <h2 id="currentBookTitle">{bookId?.replaceAll("-", " ")}</h2>
                  <div class="page-counter">
                    <span id="currentPage">{BookPage?.PageNo}</span> /{" "}
                    <span id="totalPages">{BookDetails?.Pages}</span>
                  </div>
                </div>
                <button class="menu-btn-reader">⋮</button>
              </header>

              <div class="reader-container">
                {/* <div class="page-navigation">
                  <button
                    class="nav-btn prev-btn"
                    onClick={() => book.current.pageFlip().flipPrev()}
                  >
                    ‹
                  </button>
                  <button
                    class="nav-btn next-btn"
                    onClick={() => book.current.pageFlip().flipNext()}
                  >
                    ›
                  </button>
                </div> */}

                {bookDet ? (
                  <div class="Book-page-pages" id="">
                    <HTMLFlipBook
                      onFlip={(e) => {
                        setBookPage({ ...BookPage, PageNo: e.data + 1 }); // e.data is the current page index
                      }}
                      ref={book}
                      width={window.innerWidth - 60}
                      height={600}
                    >
                      {BookPage?.Book?.map((ev, i) => (
                        <div class="" data-page={i + 1}>
                          <img
                            src={
                              process.env.REACT_APP_DOC +
                              "/Books/" +
                              BookDetails?.Book_Cover?.replace(
                                BookDetails?.PagesLength,
                                ev
                              )
                            }
                            alt={"Page " + (i + 1)}
                            class="page-image"
                          />
                        </div>
                      ))}
                    </HTMLFlipBook>
                  </div>
                ) : (
                  ""
                )}

                {/* <div class="progress-indicator">
                  <div class="progress-bar">
                    <div class="progress-fill" id="progressFill"></div>
                  </div>
                  <span class="progress-text">Reading Progress</span>
                </div> */}
              </div>
            </div>
          </div>
          <MobileBottomMenu Page="Books" />
        </div>
      </div>
    </>
  );
}
